module.exports = __webpack_public_path__ + "img/img13.d68ad654.svg";